import { createContext } from "react";

/**
 * @typedef {Object} HlsTrackState
 * @property {boolean} isPlaying Whether audio is currently playing
 * @property {boolean} isLoading Whether the current fragment is loading
 * @property {boolean} isMuted
 * @property {number} currentTime Current playback time in seconds
 * @property {number} duration Total duration in seconds
 */
/**
 * @typedef {Object} HlsStateContextValue
 * @property {HlsTrackState} hlsTrackState Reactive state of the HLS audio
 * @property {boolean} isInRoom
 * @property {object} currentTrackData
 * @property {object} previewTrack
 */

/**
 * @typedef {Object} HlsActionContextValue
 * @property {(post: object, isInRoom: boolean) => Promise<void>} playTrack Load and play a given user's track
 * @property {(userId: string, trackId: string, post: object) => Promise<void>} playTrackPreview Load and play a track's preview
 * @property {() => void} stopTrackPreview Stops track preview
 * @property {() => Promise<void>} prepareHLS Prepare HLS instance and auth token
 * @property {() => void} pauseTrack Pause playback
 * @property {() => void} reset Resets the player
 * @property {(toSeconds: number) => void} seekTrack Seek to a time in seconds
 * @property {() => void} resumePlay Resumes playing
 * @property {() => void} muteUnmute Unmute or mute the audio player
 */

/**
 * @type {React.Context<HlsActionContextValue | null>}
 */
export const HlsAudioActionsContext = createContext(null);

/**
 * @type {React.Context<HlsStateContextValue | null>}
 */
export const HlsAudioStateContext = createContext(null);
